module.exports = __webpack_public_path__ + "img/cg-outline-grey.6c3b2f05.svg";